// utils/cart.ts

import Cookies from "js-cookie";
import toast from "react-hot-toast";

const CART_KEY = "store_cart";
const ACCESS_TOKEN_KEY = "access_token";
const PROFILE_KEY = "profile";

export const addToCart = (product: any) => {
  const existingCart = Cookies.get(CART_KEY);
  let cart = existingCart ? JSON.parse(existingCart) : [];
  const productId = product?.product_id ?? product?.id;
  const tagId = product?.tag_id ?? null;
  const selectedQty = Math.max(1, Number(product?.selectedQuantity || 1));
  const stockQty = Number(product?.quantity || 100);
  const existingProduct = cart.find(
    (item: any) =>
      (item?.product_id ?? item?.id) === productId &&
      (item?.tag_id ?? null) === tagId,
  );

  if (existingProduct) {
    existingProduct.selectedQuantity = Math.min(
      (Number(existingProduct.selectedQuantity) || 1) + selectedQty,
      Number(existingProduct.quantity) || stockQty,
    );
  } else {
    cart.push({
      ...product,
      product_id: productId,
      id: productId,
      tag_id: tagId,
      quantity: stockQty,
      selectedQuantity: selectedQty,
    });
  }

  Cookies.set(CART_KEY, JSON.stringify(cart), {
    expires: 1,
    path: "/",
  });
  toast.success("تمت اضافة المنتج بنجاح!");
};

export const addMultipleToCart = (products: any[]) => {
  const existingCart = Cookies.get(CART_KEY);
  let cart = existingCart ? JSON.parse(existingCart) : [];

  products.forEach((product) => {
    const productId = product?.product_id ?? product?.id;
    const tagId = product?.tag_id ?? null;
    const quantityToAdd = 1;

    const existingProductIndex = cart.findIndex(
      (item: any) =>
        (item?.product_id ?? item?.id) === productId &&
        (item?.tag_id ?? null) === tagId,
    );

    if (existingProductIndex > -1) {
      const existingProduct = cart[existingProductIndex];
      existingProduct.selectedQuantity =
        (Number(existingProduct.selectedQuantity) || 1) + quantityToAdd;
    } else {
      cart.push({
        ...product,
        product_id: productId,
        id: productId,
        tag_id: tagId,
        selectedQuantity: quantityToAdd,
      });
    }
  });

  Cookies.set(CART_KEY, JSON.stringify(cart), {
    expires: 7,
    path: "/",
  });
};

export const getCart = () => {
  const cart = Cookies.get(CART_KEY);
  const parsed = cart ? JSON.parse(cart) : [];

  // Add default selectedQuantity to each item (user's choice, separate from stock quantity)
  return parsed.map((item: any) => ({
    ...item,
    selectedQuantity: Number(item?.selectedQuantity) || 1,
  }));
};

export const removeFromCart = (id: number) => {
  const cart = getCart();

  const updatedCart = cart.filter(
    (item: any) => (item?.product_id ?? item?.id) !== id,
  );

  Cookies.set(CART_KEY, JSON.stringify(updatedCart), {
    expires: 7,
    path: "/",
  });
};

export const updateCartItemQuantity = (
  id: number,
  quantity: number,
  tagId?: number | null,
) => {
  const cart = getCart();

  const updatedCart = cart.map((item: any) => {
    const itemId = item?.product_id ?? item?.id;
    const sameTag = (item?.tag_id ?? null) === (tagId ?? null);

    if (itemId === id && sameTag) {
      const maxQty = Math.max(1, Number(item?.quantity || 1));
      return {
        ...item,
        selectedQuantity: Math.min(
          Math.max(1, Number(quantity || 1)),
          maxQty
        ),
      };
    }

    return item;
  });

  Cookies.set(CART_KEY, JSON.stringify(updatedCart), {
    expires: 7,
    path: "/",
  });

  return updatedCart;
};

export const clearCart = () => {
  Cookies.remove(CART_KEY, { path: "/" });
};

export const clearSessionCookies = () => {
  Cookies.remove(ACCESS_TOKEN_KEY, { path: "/" });
  Cookies.remove(PROFILE_KEY, { path: "/" });
  Cookies.remove(CART_KEY, { path: "/" });
};
